export class User {
  constructor( firstName, lastName, emailAddress, phoneNumber, password, role, roleKey ) {
      this.firstName = firstName;
      this.lastName = lastName;
      this.emailAddress = emailAddress;
      this.phoneNumber = phoneNumber;
      this.password = password;
      this.role = role;
      this.roleKey = roleKey;
  }
}
